/** Host accessor for the monotonic query-generation counter. */
export interface QueryGenerationHost {
  getQueryGeneration: () => number;
}

/** Returns true when an async callback belongs to a superseded grid query. */
export function isStaleQueryGeneration(host: QueryGenerationHost, capturedGeneration: number): boolean {
  return host.getQueryGeneration() !== capturedGeneration;
}
